import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ScreenHeader.css";

/**
 * Shared screen header, mirroring the Account screen design:
 * a gradient-blue circular icon tile + Inter-800 blue title + subtitle,
 * over a hairline rule. Pass `children` to render an action on the right.
 *
 *   <ScreenHeader icon={faCalendarDays} title="Calendar" subtitle="…">
 *     <button>Add</button>   // optional right-aligned action
 *   </ScreenHeader>
 */
const ScreenHeader = ({ icon, title, subtitle, children }) => (
  <header className="screen-hd">
    <div className="screen-hd-main">
      {icon && (
        <span className="screen-hd-icon" aria-hidden="true">
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      <div className="screen-hd-text">
        <h1 className="screen-hd-title">{title}</h1>
        {subtitle && <p className="screen-hd-subtitle">{subtitle}</p>}
      </div>
    </div>
    {children && <div className="screen-hd-action">{children}</div>}
  </header>
);

export default ScreenHeader;
